/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type spaceResultSearchFragment$ref: FragmentReference;
declare export opaque type spaceResultSearchFragment$fragmentType: spaceResultSearchFragment$ref;
export type spaceResultSearchFragment = {|
  +spaceId: ?string,
  +ref: string,
  +title: ?string,
  +surface: ?number,
  +rate: ?number,
  +type: ?string,
  +searchMap: ?{|
    +location: ?$ReadOnlyArray<?number>,
    +slug: ?string,
    +place_id: ?string,
  |},
  +dataByCategory: ?{|
    +hourlyRateExclTax: ?number,
    +price: ?{|
      +amount: ?number,
      +amount_excl_tax: ?number,
    |},
    +corpoPrice: ?{|
      +amount: ?number,
      +amount_excl_tax: ?number,
    |},
    +appliedDiscountPercent: ?number,
    +capacities: ?{|
      +value: ?string
    |},
    +insta: ?boolean,
  |},
  +pictures: ?$ReadOnlyArray<?{|
    +nameId: ?string,
    +extension: ?string,
    +predictName: ?string,
  |}>,
  +urlSpacefr: ?string,
  +urlSpaceen: ?string,
  +urlSpacees: ?string,
  +reviewCounter: ?number,
  +selection: ?boolean,
  +badge: ?string,
  +technicalSheet: ?{|
    +isPublic: ?boolean
  |},
  +fidelityProgram: ?boolean,
  +isSuperhost: ?boolean,
  +covid_free: ?boolean,
  +searchSimuPrice: ?any,
  +forceGeneratePicture: ?string,
  +$refType: spaceResultSearchFragment$ref,
|};
export type spaceResultSearchFragment$data = spaceResultSearchFragment;
export type spaceResultSearchFragment$key = {
  +$data?: spaceResultSearchFragment$data,
  +$fragmentRefs: spaceResultSearchFragment$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "Literal",
  "name": "category",
  "value": "production"
},
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "amount",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "amount_excl_tax",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "datesSelected"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "disposition"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "lang"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "riders"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "spaceResultSearchFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "spaceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ref",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "lang",
          "variableName": "lang"
        }
      ],
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "surface",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SearchSpaceLocation",
      "kind": "LinkedField",
      "name": "searchMap",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "location",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slug",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "place_id",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        (v0/*: any*/)
      ],
      "concreteType": "DataByCategory",
      "kind": "LinkedField",
      "name": "dataByCategory",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hourlyRateExclTax",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Price",
          "kind": "LinkedField",
          "name": "price",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        },
        {
          "alias": "corpoPrice",
          "args": [
            {
              "kind": "Literal",
              "name": "input",
              "value": {
                "byViewer": true
              }
            }
          ],
          "concreteType": "Price",
          "kind": "LinkedField",
          "name": "price",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": "price(input:{\"byViewer\":true})"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "appliedDiscountPercent",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SpaceCapacities",
          "kind": "LinkedField",
          "name": "capacities",
          "plural": false,
          "selections": [
            {
              "alias": "value",
              "args": [
                (v0/*: any*/),
                {
                  "kind": "Variable",
                  "name": "disposition",
                  "variableName": "disposition"
                }
              ],
              "kind": "ScalarField",
              "name": "maxRidersByParams",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "insta",
          "storageKey": null
        }
      ],
      "storageKey": "dataByCategory(category:\"production\")"
    },
    {
      "alias": "pictures",
      "args": [
        {
          "kind": "Literal",
          "name": "count",
          "value": 6
        }
      ],
      "concreteType": "SearchSpacePicture",
      "kind": "LinkedField",
      "name": "searchElasPictures",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "nameId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "extension",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "predictName",
          "storageKey": null
        }
      ],
      "storageKey": "searchElasPictures(count:6)"
    },
    {
      "alias": "urlSpacefr",
      "args": [
        {
          "kind": "Literal",
          "name": "lang",
          "value": "fr"
        }
      ],
      "kind": "ScalarField",
      "name": "urlByLang",
      "storageKey": "urlByLang(lang:\"fr\")"
    },
    {
      "alias": "urlSpaceen",
      "args": [
        {
          "kind": "Literal",
          "name": "lang",
          "value": "en"
        }
      ],
      "kind": "ScalarField",
      "name": "urlByLang",
      "storageKey": "urlByLang(lang:\"en\")"
    },
    {
      "alias": "urlSpacees",
      "args": [
        {
          "kind": "Literal",
          "name": "lang",
          "value": "es"
        }
      ],
      "kind": "ScalarField",
      "name": "urlByLang",
      "storageKey": "urlByLang(lang:\"es\")"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "reviewCounter",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "selection",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "badge",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SpaceTechnicalSheet",
      "kind": "LinkedField",
      "name": "technicalSheet",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isPublic",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fidelityProgram",
      "storageKey": null
    },
    {
      "alias": "isSuperhost",
      "args": [
        {
          "kind": "Literal",
          "name": "tags",
          "value": [
            "SUPERHOST"
          ]
        }
      ],
      "kind": "ScalarField",
      "name": "hasTags",
      "storageKey": "hasTags(tags:[\"SUPERHOST\"])"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "covid_free",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        (v0/*: any*/),
        {
          "kind": "Variable",
          "name": "dates",
          "variableName": "datesSelected"
        },
        {
          "kind": "Variable",
          "name": "riders",
          "variableName": "riders"
        }
      ],
      "kind": "ScalarField",
      "name": "searchSimuPrice",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "forceGeneratePicture",
      "storageKey": null
    }
  ],
  "type": "Space",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = '639912d402d8688b1b9cb63accd54cbb';

module.exports = node;
